import src from "IMAGE";
export default { src, width: 573, height: 138, blurWidth: 0, blurHeight: 0};
